import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import DoorPrizes from "@/pages/DoorPrizes";

export const Route = createFileRoute("/door-prizes")({
  head: () => pageHead({
    title: 'Door Prizes & Giveaways',
    description: 'Enter Rex & Sons RVs door prize drawings and giveaways — win camping gear, accessories and more at our Castle Hayne, NC events.',
    path: '/door-prizes',
  }),
  component: DoorPrizes,
});
